import { bl_inv_outlet_type_hdr_RowClass } from '../../dbschema';
import { BaseContainerModel } from '../base-container.model';

export class InventoryOutletTypeContainerModel extends BaseContainerModel {
  bl_inv_outlet_type_hdr: bl_inv_outlet_type_hdr_RowClass = new bl_inv_outlet_type_hdr_RowClass();
}
